import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from '../services/labels/labels.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { mspGlobal } from '../global/mspGlobal';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { delay, firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService {
	constructor(
		private Router: Router,
		private AuthLoginService: AuthLoginService,
		private CryptoService: CryptoService,
		private ProfileService: ProfileService,
		private NotificationService: NotificationService,
		private mspGlobal: mspGlobal
	) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		//Giving 500ms on route change return so the transition animation finish when the route return faster than it
		if ((!route.data || !route.data.rules || !route.data.rules.includes('noLogin')) && !this.AuthLoginService.isLoggedIn()) {
			this.Router.navigate(['/login'], { queryParams: { gt: this.CryptoService.encryptB64(state.url) } });

			await delay(500);
			return false;
		}

		if (this.AuthLoginService.isLoggedIn()) {
			const user = await firstValueFrom(this.ProfileService.setLocalUser());
			const sessionStatus = <any>user.sessionStatus;
			if (sessionStatus === '') {
				this.AuthLoginService.removeSessionToken();
				this.AuthLoginService.removeSessionStatus(this.ProfileService.userData().id, this.ProfileService.userData().idAnalyst);
				this.NotificationService.setNotificationMessage(this.mspGlobal.labels.lbl_voce_foi_desconectado_reconecte);
				this.Router.navigate(['/login'], { queryParams: { gt: this.CryptoService.encryptB64(state.url) } });
				localStorage.setItem('updateEvent', Math.random().toString());
				await delay(500);
				return false;
			}
		}

		await delay(500);
		return true;
	}
}
